<template lang="pug">

    .col-span-6
        label(class='block text-sm font-medium text-gray-700'
            :for="'field_' + parameter.id"
            :class="{ 'required': parameter['required']}") {{ parameter.name }}
        input(class='mt-1 block w-full shadow-sm border-gray-300 rounded-md'
        +' focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm'
            type='text'
            autocomplete='off'
            @input='handleInput'
            :id="'field_' + parameter.id"
            :value='value'
            :class="{ 'form-error': !!error }"
            :placeholder="placeholder")
        p.mt-2.p-1.rounded.text-sm.text-red-500.bg-gray-100(v-if='!!error')
            | {{ error.message || 'Поле обязательно для заполнения' }}

</template>

<script>
export default {
    name: 'ItemFormGroupParameterText',

    props: {
        parameter: {
            type: Object,
        },

        value: {
            type: String,
        },

        error: {
            type: [Object, Boolean],
        },
    },

    data: () => ({
        placeholder: '',
    }),

    mounted() {
        if (this.parameter.hasOwnProperty('extra_serialized')) {
            // const placeholder = JSON.parse(this.parameter.extra_serialized).placeholder
            const placeholder = this.parameter.extra_serialized.placeholder
            if (placeholder && placeholder.length > 0) this.placeholder = placeholder
        }
    },

    methods: {
        handleInput($event) {
            this.$emit('input', $event.target.value)
        },
    },
}
</script>
